'use client';
import { createStyles } from '@s7/styles';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var useStyles = createStyles((theme, { zIndex, radius, padding, breakpoints })=>{
    return {
        inner: {
            position: 'fixed',
            width: '100%',
            maxHeight: '100%',
            top: 'env(safe-area-inset-top)',
            bottom: 'env(safe-area-inset-bottom)',
            left: 'env(safe-area-inset-left)',
            right: 'env(safe-area-inset-right)',
            pointerEvents: 'none',
            zIndex
        },
        content: _extends({
            boxSizing: 'border-box',
            display: 'block',
            pointerEvents: 'all',
            outline: 0,
            textDecoration: 'none',
            WebkitTapHighlightColor: 'transparent',
            backgroundColor: theme.palette.background.content,
            boxShadow: theme.shadows.z500
        }, padding && {
            padding: theme.fn.space(padding)
        }, radius && {
            borderRadius: theme.fn.borderRadius(radius)
        }, theme.fn.responsive(breakpoints)(({ radius, padding })=>_extends({}, padding && {
                padding: theme.fn.space(padding)
            }, radius && {
                borderRadius: theme.fn.borderRadius(radius)
            })))
    };
});

export { useStyles as default };
//# sourceMappingURL=ModalContent.styles.js.map
